import { IApplicationState } from '../../types/redux';

export function getIsUpcomingSalePopupOpen(state: IApplicationState): boolean {
  return state.upcomingSale.showPopup || false;
}
